import { createTransform } from 'redux-persist';

/** Login fields kept in memory for the screens that need them, but never written
 * to (or read back from) browser storage (#152). */
export const PERSIST_EXCLUDED_USER_FIELDS = [
	'crmUsername',
	'crmPassword',
	'socialMediaCredentials',
	'websiteCredentials',
];

const stripFields = (user) => {
	if (!user || typeof user !== 'object') return user;
	const copy = { ...user };
	PERSIST_EXCLUDED_USER_FIELDS.forEach((field) => delete copy[field]);
	return copy;
};

const stripEach = (list, pick) => (Array.isArray(list) ? list.map(pick) : list);

/** Removes the excluded fields from every user object the slice holds: the active
 * user, each signed-in account, and the admin's client list. */
export const stripPrivateUserFields = (userState) => {
	if (!userState || typeof userState !== 'object') return userState;
	const next = { ...userState };
	if ('currentUser' in next) next.currentUser = stripFields(next.currentUser);
	if ('accounts' in next) {
		next.accounts = stripEach(next.accounts, (a) =>
			a && typeof a === 'object' ? { ...a, currentUser: stripFields(a.currentUser) } : a
		);
	}
	if ('allUsers' in next) next.allUsers = stripEach(next.allUsers, stripFields);
	return next;
};

/** Removes the excluded fields from the client an admin is impersonating. */
export const stripPrivateAdminFields = (adminState) => {
	if (!adminState || typeof adminState !== 'object') return adminState;
	if (!('impersonatedUser' in adminState)) return adminState;
	return { ...adminState, impersonatedUser: stripFields(adminState.impersonatedUser) };
};

const stripSlice = (state, key) =>
	key === 'user' ? stripPrivateUserFields(state) : stripPrivateAdminFields(state);

// Strip on save, and on load too so values persisted before #152 are dropped.
export const privateUserFieldsTransform = createTransform(stripSlice, stripSlice, {
	whitelist: ['user', 'admin'],
});
